import { Box, Button, Flex, Image } from '@amzn/ring-ui-react-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AppRoutes } from 'src/routes';

export const NotFound = () => {
  const { t } = useTranslation('features.bestOfRing');
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      height="100%"
      px={6}
    >
      <Image
        src="/assets/images/top-ring-videos-not-found.png"
        alt=""
        role="presentation"
        maxW={600}
        width="100%"
      />
      <Box textAlign="center">
        <Box
          as="h1"
          textStyle={{
            base: 'heading-normal-medium',
            m: 'heading-large-medium',
          }}
          mt={4}
          mb={6}
        >
          {t('not-found.text')}
        </Box>
        <Link to={AppRoutes.BestOfRing}>
          <Box
            as={Button}
            variant="outline"
            maxWidth={{ base: '100%', m: '266px' }}
            width="100%"
          >
            {t('not-found.button')}
          </Box>
        </Link>
      </Box>
    </Flex>
  );
};
